import axios from "axios";
import swal from "sweetalert";
import { loginConfirmedAction, Logout } from "../store/actions/AuthActions";

export function signUp(email, password) {
  //axios call
  const postData = {
    email,
    password,
  };
  return axios.post(``, postData);
}

export function login(email, password) {
  const postData = {
    email,
    password,
  };
  return axios.post(
    `https://identitytoolkit.googleapis.com/v1/accounts:signInWithPassword?key=AIzaSyD3RPAp3nuETDn9OQimqn_YF6zdzqWITII`,
    postData
  );
}

export function formatError(errorResponse) {
  switch (errorResponse.error.message) {
    case "EMAIL_EXISTS":
      swal("Oops", "Email already exists", "error");
      break;
    case "EMAIL_NOT_FOUND":
      swal("Oops", "Email not found", "error", { button: "Try Again!" });
      break;
    case "INVALID_PASSWORD":
      swal("Oops", "Invalid Password", "error", { button: "Try Again!" });
      break;
    case "USER_DISABLED":
      return "User Disabled";

    default:
      return "";
  }
}

export function saveTokenInLocalStorage(tokenDetails) {
  tokenDetails.expireDate = new Date(
    new Date().getTime() + 43200000 // 12 hours
  );
  localStorage.setItem("userDetail", JSON.stringify(tokenDetails));
}

export function runLogoutTimer(dispatch, timer, navigate) {
  setTimeout(() => {
    //dispatch(Logout(history));
    dispatch(Logout(navigate));
  }, timer);
}

export function checkAutoLogin(dispatch, navigate) {
    const tokenDetailsString = localStorage.getItem("userDetail");
    let tokenDetails = "";
    if (!tokenDetailsString) {
      dispatch(Logout(navigate));
      return;
    }
  
    tokenDetails = JSON.parse(tokenDetailsString);
    let expireDate = new Date(tokenDetails.expireDate);
    let todaysDate = new Date();
  
    if (todaysDate > expireDate) {
      dispatch(Logout(navigate));
      return;
    }
  
    dispatch(loginConfirmedAction(tokenDetails));
  
    const remainingTime = expireDate.getTime() - todaysDate.getTime();
    runLogoutTimer(dispatch, remainingTime, navigate);
  }

export function isLogin() {
  const tokenDetailsString = localStorage.getItem("userDetail") || "";
  console.log("tokenDetailsString", tokenDetailsString);
  if (tokenDetailsString) {
    return true;
  } else {
    return false; // TODO:
  }
}
